const translations = {
  "en": {
    "Got it": "Got it",
    "I'm reading your accounts now": "I'm reading your accounts now",
    "Turn on notifications": "Turn on notifications",
    "Your first read is ready in a few minutes. Turn on notifications and I'll send it the moment it's done.": "Your first read is ready in a few minutes. Turn on notifications and I'll send it the moment it's done."
  },
  "zh-tw": {
    "Got it": "了解",
    "I'm reading your accounts now": "我正在閱讀您的帳戶。",
    "Turn on notifications": "開啟通知",
    "Your first read is ready in a few minutes. Turn on notifications and I'll send it the moment it's done.": "您的首次閱讀將在幾分鐘內準備就緒。開啟通知，我會在完成時立即為您發送。"
  }
};

export default translations;
